

























































































import {
  computed,
  defineComponent,
  onMounted,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useRouter, useFormat } from 'vivat';

import CommonChip from '@/components/CommonChip.vue';
import CommonValueItem from '@/components/CommonValueItem.vue';

import getDelivery from '@/gql/delivery/getDelivery.gql';
import getCompany from '@/gql/company/getCompany.gql';
import updateDeliveryStatus from '@/gql/delivery/updateDeliveryStatus.gql';

import useDelivery from '@/useDelivery';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import { AUTH_TOKEN } from '@/useApollo';

const UpdateTracking = defineComponent({
  components: {
    CommonChip,
    CommonValueItem,
  },
  setup() {
    const confirmPopup = ref(false);
    const { distanceTypeToChipClass } = useDeliveryAreaCode();

    const { router, route } = useRouter();
    const delivery: Ref<any> = ref({});
    const { result: getDeliveryResult, loading } = useQuery(getDelivery, computed(() => ({
      trackingCode: route.value.params.id,
    })), () => ({
      fetchPolicy: 'network-only',
    }));
    const deliveryResult = useResult(getDeliveryResult, {}, (data) => data.delivery);
    watch(() => deliveryResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal) {
        delivery.value = {
          ...deliveryResult.value,
          deliveryLogs: [
            ...deliveryResult.value.deliveryLogs,
            { id: -1, status: 'PURCHASE', createdAt: deliveryResult.value.orderDate },
          ],
        };
      }
    });
    const computedAddress = computed(() => {
      if (deliveryResult.value.id) return `${deliveryResult.value.address?.address} ${deliveryResult.value.address.province?.nameInThai} ${deliveryResult.value.address.district?.nameInThai ? deliveryResult.value.address.district.nameInThai : ''} ${deliveryResult.value.address.subdistrict?.nameInThai ? deliveryResult.value.address.subdistrict.nameInThai : ''}`;
      return '';
    });
    const {
      shipmentStatusClassMap,
      translate: shipmentStatusTranslate,
      english: statusListEng,
    } = useDelivery();
    const reversedDeliveryLog = computed(() => {
      if (!loading.value) {
        if (delivery.value?.deliveryLogs?.length <= 0) return undefined;
        return delivery.value?.deliveryLogs?.sort((deliveryLogs: any, dL: any) => dL.id - deliveryLogs.id);
      }
      return undefined;
    });

    function toDate(val: any) {
      return useFormat.date(val).displayFullThaiDate();
    }

    const updateDeliveryItem = ref({
      id: -1,
      status: 'PENDING',
    });
    const updateDeliveryStatusMutation = useMutation(updateDeliveryStatus, () => ({
      variables: {
        id: deliveryResult.value.id,
        input: {
          status: updateDeliveryItem.value.status,
        },
      },
      refetchQueries: ['getDelivery'],
    }));
    function updateDeliveryStatusAction() {
      updateDeliveryStatusMutation.mutate();
    }
    updateDeliveryStatusMutation.onDone(() => {
      delivery.value.status = updateDeliveryItem.value.status;
      confirmPopup.value = !confirmPopup.value;
    });

    const { result: companyResult } = useQuery(getCompany);
    const company = useResult(companyResult, { logoUrl: '/logo_fast.svg', backgroundUrl: '/img/background/bg-tms.png' }, (data: any) => data.company);

    const computedDeliveryArea = computed(() => {
      if (delivery.value.area !== null) return delivery.value.area;
      return { code: 'NA', name: '', distanceType: '' };
    });

    async function checkAuthenticate() {
      if (!(localStorage.getItem(AUTH_TOKEN))) {
        router.push({
          name: 'Login',
          query: {
            redirectName: 'AppUpdateTrackingStatus',
            id: route.value.params.id,
          },
        });
      }
    }

    onMounted(async () => {
      await checkAuthenticate();
    });

    return {
      toDate,
      distanceTypeToChipClass,
      company,

      updateDeliveryItem,
      confirmPopup,

      delivery,
      computedAddress,

      statusListEng,
      shipmentStatusClassMap,
      shipmentStatusTranslate,
      reversedDeliveryLog,

      updateDeliveryStatusAction,

      computedDeliveryArea,
    };
  },
});

export default UpdateTracking;
